import { render, staticRenderFns } from "./formPlanNew.vue?vue&type=template&id=08b046b4&scoped=true&"
import script from "./formPlanNew.vue?vue&type=script&lang=js&"
export * from "./formPlanNew.vue?vue&type=script&lang=js&"
import style0 from "./formPlanNew.vue?vue&type=style&index=0&id=08b046b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b046b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b046b4')) {
      api.createRecord('08b046b4', component.options)
    } else {
      api.reload('08b046b4', component.options)
    }
    module.hot.accept("./formPlanNew.vue?vue&type=template&id=08b046b4&scoped=true&", function () {
      api.rerender('08b046b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formPlanNew.vue"
export default component.exports